module.exports = __webpack_public_path__ + "img/mypost.5aafbbe2.svg";